import { all, takeLatest, call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';
import { navigate } from '@reach/router';
import { Paths } from '@/pages/routers';
import { executeAfterToast } from '@/utils';
import {
  fetchServicesActions,
  fetchServiceByIdActions,
  createServiceActions,
  editServiceActions,
  deleteServiceActions,
} from '@/redux/actions/service-directory/service-catalogue';
import { ServiceCatalogueInstance } from '@/services/service-directory/service-catalogue';

export function* fetchServicesSaga(action: ActionType<typeof fetchServicesActions.request>) {
  try {
    const { entityId, pageNumber, pageSize, searchText, loadingMore } = action.payload;
    const { data, paging } = yield call(
      ServiceCatalogueInstance.fetchServices,
      entityId,
      pageNumber,
      pageSize,
      searchText
    );

    yield put(fetchServicesActions.success(data, paging, loadingMore));
  } catch (error) {
    yield put(fetchServicesActions.failure(error));
  }
}

export function* fetchServiceSaga(action: ActionType<typeof fetchServiceByIdActions.request>) {
  try {
    const { entityId, id } = action.payload;
    const service = yield call(ServiceCatalogueInstance.fetchService, entityId, id);
    yield put(fetchServiceByIdActions.success(service));
  } catch (err) {
    yield put(fetchServiceByIdActions.failure(err));
  }
}

export function* createServiceSaga(action: ActionType<typeof createServiceActions.request>) {
  try {
    const { entityId, service } = action.payload;
    yield call(ServiceCatalogueInstance.createService, entityId, service);
    yield put(createServiceActions.success());
    executeAfterToast(() => navigate(`${Paths.Dashboard}${Paths.MyServices}`));
  } catch (err) {
    yield put(createServiceActions.failure(err));
  }
}

export function* editServiceSaga(action: ActionType<typeof editServiceActions.request>) {
  try {
    const { entityId, id, service } = action.payload;

    yield call(ServiceCatalogueInstance.updateService, entityId, id, service);
    yield put(editServiceActions.success());
    executeAfterToast(() => navigate(`${Paths.Dashboard}${Paths.MyServices}`));
  } catch (err) {
    yield put(editServiceActions.failure(err));
  }
}

export function* deleteServiceSaga(action: ActionType<typeof deleteServiceActions.request>) {
  try {
    const { entityId, id } = action.payload;

    yield call(ServiceCatalogueInstance.deleteService, entityId, id);
    yield put(deleteServiceActions.success());
    executeAfterToast(() => navigate(`${Paths.Dashboard}${Paths.MyServices}`));
  } catch (err) {
    yield put(deleteServiceActions.failure(err));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchServicesActions.request.type, fetchServicesSaga),
    takeLatest(fetchServiceByIdActions.request.type, fetchServiceSaga),
    takeLatest(createServiceActions.request.type, createServiceSaga),
    takeLatest(editServiceActions.request.type, editServiceSaga),
    takeLatest(deleteServiceActions.request.type, deleteServiceSaga),
  ]);
}
